export enum ReportVisualScale {
  SM = "SM",
  MD = "MD",
  LG = "LG"
}
